import { put, takeLatest, select, Effect } from 'redux-saga/effects'
import getConstants from '../../../constants'
import {
  hasSimpleModeFlag,
  simpleModeSearchPair,
  getCountryLanguage,
  getSupportedEUCountry,
} from 'utils'

import { changed } from '../../Navigation/actions'
import * as actionTypes from '../actionTypes'
import { sendPageViewData } from 'helpers/analytics'
import * as selectors from '../selectors'

const constants = getConstants()

export function* selectStoreWorker(
  action: ActionType,
): Generator<Effect, any, any> {
  const { storeId } = action.payload
  const {
    history,
    location: { search },
  } = window
  const isSimpleMode = hasSimpleModeFlag(search)
  const areaCode = yield select(selectors.areaCode)

  let newBaseName = constants.BASE_NAME

  if (constants.IS_EU) {
    if (areaCode) {
      newBaseName = `/${areaCode}/${getCountryLanguage(areaCode)}`
    } else {
      const supportedEUCountry = getSupportedEUCountry(constants.COUNTRY)
      if (supportedEUCountry !== constants.COUNTRY) {
        newBaseName = `/${supportedEUCountry}/${getCountryLanguage(
          supportedEUCountry,
        )}`
      }
    }
  }
  storeId
    ? history.replaceState(
        history.state,
        '',
        `${newBaseName}/detail/${storeId}${
          isSimpleMode ? `?${simpleModeSearchPair}` : ''
        }`,
      )
    : history.replaceState(history.state, '', constants.BASE_NAME)

  yield put(
    changed({
      action: 'REPLACE',
      location: { pathname: `${newBaseName}/detail/${storeId}` },
    }),
  )
  sendPageViewData()
}

function* selectStoreSaga() {
  yield takeLatest(actionTypes.SELECTED_STORE_UPDATED, selectStoreWorker)
}

export default selectStoreSaga
